import React, { useEffect, useState } from 'react';
import { useSettings } from '../../providers/SettingsContext';
import { getDisplayImageUrl } from '../../utils/imageUtils';

const SESSION_KEY = 'rem_promo_popup_shown';

const PromoPopup = () => {
  const { settings } = useSettings();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const popup = settings?.promoPopup;
    if (!popup?.isEnabled || !popup?.imageUrl) return;
    if (sessionStorage.getItem(SESSION_KEY)) return;
    setVisible(true);
  }, [settings]);

  const handleClose = () => {
    sessionStorage.setItem(SESSION_KEY, '1');
    setVisible(false);
  };

  if (!visible) return null;

  const imageUrl = getDisplayImageUrl(settings?.promoPopup?.imageUrl);

  return (
    <div
      onClick={handleClose}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.75)',
        zIndex: 10000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        animation: 'promoFadeIn 0.3s ease',
      }}
    >
      <style>{`
        @keyframes promoFadeIn {
          from { opacity: 0; }
          to   { opacity: 1; }
        }
        @keyframes promoSlideUp {
          from { opacity: 0; transform: translateY(30px) scale(0.96); }
          to   { opacity: 1; transform: translateY(0) scale(1); }
        }
      `}</style>

      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          position: 'relative',
          maxWidth: '480px',
          width: '100%',
          borderRadius: '16px',
          overflow: 'hidden',
          boxShadow: '0 25px 60px rgba(0,0,0,0.5)',
          animation: 'promoSlideUp 0.35s ease',
        }}
      >
        <button
          onClick={handleClose}
          title="Cerrar"
          style={{
            position: 'absolute',
            top: '12px',
            right: '12px',
            width: '36px',
            height: '36px',
            borderRadius: '50%',
            background: 'rgba(0,0,0,0.6)',
            border: 'none',
            color: '#fff',
            fontSize: '16px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1,
            transition: 'background 0.2s',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.background = 'rgba(0,0,0,0.85)')}
          onMouseLeave={(e) => (e.currentTarget.style.background = 'rgba(0,0,0,0.6)')}
        >
          <i className="fas fa-times" />
        </button>

        <img
          src={imageUrl}
          alt="Promoción"
          style={{
            width: '100%',
            display: 'block',
            maxHeight: '70vh',
            objectFit: 'cover',
          }}
        />
      </div>
    </div>
  );
};

export default PromoPopup;
